const chat = require('../../../../../components/chat/chat')
const chatQuickview = require('../../../../../components/chat/chat-container')
const chatActions = require('../../../../../components/chat/chat-actions')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./sale-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:       { start: (detail) => { load(detail)         } },
    submit:     { start: (detail) => { submit(detail)       } },
    typing:     { start: (detail) => { typing(detail)       } },
    beforeChat: { start: (detail) => { beforeChat(detail)   } },
}

const SALE_QUESTIONS = [
    "What is the status of the sale?",
    "What is the total amount of the sale?",
    "Were there any changes in the sale orders?",
    "Can I get a summary of this sale?",
]

const SALE_BEFORE_QUESTIONS = [
    "Is credit available?",
    "Price for this client?",
    "Is there stock available for sale?",
    "Is a discount applicable?",
]

function getGeneralQuestions(type) {
    if (type === "sale") {
        return SALE_QUESTIONS
    }

    if (type === "saleBefore") {
        return SALE_BEFORE_QUESTIONS
    }

}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Sale
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: ${recordId}
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this sale
                </div>
            </div>
        </div>
    `;

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "sale",
                "entity": "sale",
                "question": detail.question ?? "",
                "recordId": recordId,
                "ev": detail.ev,
                "generalQuestions": getGeneralQuestions("sale"),
                "cardWarning": cardWarning,
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj,
            "generalQuestions": getGeneralQuestions("sale"),
            "cardWarning": cardWarning,
        })
    }

}

function beforeChat(detail) {

    const htmlFc = handler.getDataFc()

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Sale Before
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: Not available
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this sale before
                </div>
            </div>
        </div>
    `;

    const dataToSend = handler.getValuesForChat(detail, htmlFc)
    if (dataToSend) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "saleBefore",
                "entity": "sale",
                "data": dataToSend,
                "question": detail.question ?? "",
                "ev": detail.ev,
                "generalQuestions": getGeneralQuestions("saleBefore"),
                "cardWarning": cardWarning,
            }
        )
    }
}

function typing(detail) {
    chatHandler.typing(detail)
}